export enum ChipVariant {
  FILTER = 'filter',
  CHOICE = 'choice',
  DROPDOWN = 'dropdown',
  INPUT = 'input'
}
